import { useState, useEffect } from 'react'
import { getEmpsStatusAPI } from '../services/status'

function UseEmpsStatus() {
  const [data, setData] = useState([])
  useEffect(() => {
    const getData = async () => {
      const resp = await getEmpsStatusAPI()
      if (!resp) return
      if (resp.status) {
        const newData = resp?.result.map((d, i) => {
          return { value: d?.id, label: d?.status_name || d?.status }
        })

        setData(newData)
      } else {
        setData([])
      }
    }
    getData()
  }, [])

  return data
}

export default UseEmpsStatus
